









import { Prop, Component, Vue } from "vue-property-decorator";
import OtherCompanyConstructionEdit from "../components/OtherCompanyConstructionEdit.vue";
// import SelectOption from "@/common/ui/presenters/select-option";
import {
  getOtherCompanyConstructionEdit,
  saveOtherCompanyConstruction
} from "../../api/other-company-construction-api";
// import { templateApi } from "@/api";
import OtherCompanyConstructionFormData from "../../models/factories/OtherCompanyConstructionFormData";
import createOtherCompanyConstructionOutput from "../../models/factories/createOtherCompanyConstructionOutput";
import { Construction, getConstruction } from "../../api/construction-api";

@Component({
  components: {
    OtherCompanyConstructionEdit
  }
})
export default class OtherCompanyConstructionEditPage extends Vue {
  @Prop({ default: 0 }) id!: string;
  otherCompanyConstruction = createOtherCompanyConstructionOutput();
  private construction: Construction[] = [];

  templates = "";
  taskTypes = "";

  private async initOtherCompanyConstruction() {
    this.otherCompanyConstruction = await getOtherCompanyConstructionEdit(
      this.id
    );
  }

  private async loadConstructionList() {
    this.construction = await getConstruction();
  }

  get constructionOptions() {
    return [
      ...this.construction.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    ];
  }

  private created() {
    this.loadConstructionList();
    this.initOtherCompanyConstruction();
  }

  async ok() {
    await this.save();
    this.goListPage();
  }

  private async save() {
    if (!this.otherCompanyConstruction) return;
    this.otherCompanyConstruction.id = this.id;
    const d = OtherCompanyConstructionFormData(this.otherCompanyConstruction);
    await saveOtherCompanyConstruction(d);
  }

  private goListPage() {
    this.$router.push({ name: "other-company-construction-list" });
  }

  cancel() {
    this.goListPage();
  }
}
